import React, { useRef } from 'react';
import styles from './LocalPopup.module.scss';
import { useOnClickOutside } from '../../hooks/useClickOutside';

type Props = {
  children: React.ReactNode;
  content: React.ReactNode;
  open: boolean;
  onClose: () => void;
};

function LocalPopup(props: Props) {
  const { children, content, open, onClose } = props;
  const wrapperRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(wrapperRef, onClose);

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      {children}
      {open &&
      <div className={styles.content}>
        {content}
      </div>
      }
    </div>
  );
}

export default LocalPopup;
